module.exports = __webpack_public_path__ + "static/media/ios-pizza.e1b05414.svg";